export const inspectTable = [
  {
    content: "위험성평가 실시 및 적정성",
    isChecked: "",
  },
];
